module.exports = __webpack_public_path__ + "static/media/trn-2.186acd9f.jpg";